import React, { memo } from 'react';
import { DivTitle } from '../../../styles';
import { RADIO_OPTIONS, RadioValues } from '../../../constants';
import FnRadioGroup from '../../../../../components/elements/FnRadioGroup/index';

const RipOutputOpacityBlock = () => {
  return (
    <>
      <DivTitle>RIP - Output opacity</DivTitle>
      <FnRadioGroup
        propertyValue="value"
        propertyLabel="name"
        options={RADIO_OPTIONS}
        value={RadioValues.No}
        title="Remove Background"
        name="removeBackground"
        disabled={true}
      />
    </>
  );
};

export default memo(RipOutputOpacityBlock);
